import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../shared/auth.service';
import { BackendService } from '../shared/backend.service';
import { NotificationService } from '../notification.service';
import { DatePipe } from '@angular/common';
import { AlertmessageService } from '../shared/alertmessage.service';
import CONFIG from 'src/config';

@Component({
  selector: 'app-business-enroll',
  templateUrl: './business-enroll.component.html',
  styleUrls: ['./business-enroll.component.scss'],
  providers: [DatePipe],
})
export class BusinessEnrollComponent implements OnInit {
  enrollForm: FormGroup;
  enrollFormBusiness: FormGroup;

  files: FileList;
  DriversLicensefiles: FileList;
  NationalInsuranceCardfiles: FileList;
  Beneficialfiles: FileList;
  Authorizedfiles: FileList;
  Businessfiles: FileList;
  name: any;
  DriversLicensename: any;
  NationalInsuranceCardname: any;
  Beneficialname: any;
  Authorizedname: any;
  Businessname: any;



  filestring: any;
  DriversLicensefilestring: any;
  NationalInsuranceCardfilestring: any;
  Beneficialstring: any;
  Authorizedstring: any;
  Businessstring: any;




  fileFormat: any;
  DriversLicensefileFormat: any;
  NationalInsuranceCardfileFormat: any;
  BeneficialfileFormat: any;
  AuthorizedfileFormat: any;
  BusinessfileFormat: any;




  Birthday = new FormControl();
  loadingData1: boolean = true;
  uploadpassportfiles: boolean = false;
  UploadNationalInsurancefiles: boolean = false;

  fileInput: string = 'Select file*';
  DriversLicensefileInput: string = 'Select file*';
  NationalInsuranceCardfileInput: string = 'Select file*';
  BeneficialfileInput: string = 'Select file*';
  AuthorizedfileInput: string = 'Select file*';
  BusinessfileInput: string = 'Select file*'
  cancel: boolean = false;
  Identifications: any;
  Individual: boolean = false;
  Business: boolean = false;
  accounttype: any;
  selected: true
  businesstype: string[] = ['Sample', 'Sample2'];

  passportNumberEnable: boolean = false;
  drivingLincenceNumberEnable: boolean = false;

  constructor(
    public _formBuilder: FormBuilder,
    public _router: Router,
    public _authService: AuthService,
    public _backendservice: BackendService,
    public _notificationService: NotificationService,
    public _datepipe: DatePipe,
    public _alert: AlertmessageService

    //public _resetFormService: ResetFormService
  ) { }

  ngOnInit(): void {
  
    this.setForm2();
    this.setFormBusiness();
    this.uploadpassportfiles = false;
    this.UploadNationalInsurancefiles = false
  }

  radioChange(event) {
   // console.log(event.value);
    this.accounttype = event.value;
    //console.log(this.accounttype)
    //  console.log(this.accounttype);
    if (event.value == 0) {
      this.accounttype = "Individual";
      //console.log(this.accounttype);
      this.Individual = true;
      this.Business = false;
      return this.Individual;
    }

    else {
      this.accounttype = "Business"
      // console.log(this.accounttype);
      this.Business = true;
      this.Individual = false;
      return this.Business;
    }


  }



  ClearFileds() {

    // console.log("testtt")
    this.cancel = true;
    this.Business = false;
    this.Individual = false;

    // this.radioChange(event);
  }


  onFileChange(event) {
    this.files = event.target.files;

    if (this.files[0].name.length < 30) {
      var str = this.files[0].name;
      this.fileInput = str.slice(0, 30);
    } else {
      var str = this.files[0].name;
      this.fileInput = str.slice(0, 25) + '...' + str.slice(-4);
    }
    if (this.files[0].type == "image/jpg" || this.files[0].type == "application/pdf" ||
      this.files[0].type == "image/jpeg") {
      this.name = this.files[0].name;
      this.fileFormat = this.files[0].type;
      //console.log(this.fileFormat);
      //// console.log(this.files);
      var reader = new FileReader();
      reader.onload = this._handleReaderLoadded.bind(this);
      reader.readAsBinaryString(this.files[0]);
    }
    else {
      this.loadingData1 = true;
      this._alert.openConfirmationDialo11("Please select a jpg/jpeg/pdf file to proceed.");
      return true;
    }

  }
  _handleReaderLoadded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.filestring = btoa(binaryString); //Convaerting Binary String Data
    ////console.log(this.filestring);

  }
  onFileChangeDriversLicense(event) {
    this.DriversLicensefiles = event.target.files;


    if (this.DriversLicensefiles[0].name.length < 30) {
      var str = this.DriversLicensefiles[0].name;
      this.DriversLicensefileInput = str.slice(0, 30);
    } else {
      var str = this.DriversLicensefiles[0].name;
      this.DriversLicensefileInput = str.slice(0, 25) + '...' + str.slice(-4);
    }

    if (
      this.DriversLicensefiles[0].type == "image/jpg" || this.DriversLicensefiles[0].type == "application/pdf" || this.DriversLicensefiles[0].type == "image/jpeg"
    ) {
      this.DriversLicensename = this.DriversLicensefiles[0].name;
      this.DriversLicensefileFormat = this.DriversLicensefiles[0].type;
      //console.log(this.fileFormat);
      //// console.log(this.files);
      var reader = new FileReader();
      reader.onload = this._handleReaderLoaddedDriversLicense.bind(this);
      reader.readAsBinaryString(this.DriversLicensefiles[0]);
    }
    else {
      this.loadingData1 = true;
      this._alert.openConfirmationDialo11("Please select a jpg/jpeg/pdf file to proceed.");
      return true;
    }
  }
  _handleReaderLoaddedDriversLicense(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.DriversLicensefilestring = btoa(binaryString); //Convaerting Binary String Data
    ////console.log(this.filestring);

  }


  onFileChangeNationalInsuranceCard(event) {
    this.NationalInsuranceCardfiles = event.target.files;

    if (this.DriversLicensefiles[0].name.length < 30) {
      var str = this.NationalInsuranceCardfiles[0].name;
      this.NationalInsuranceCardfileInput = str.slice(0, 30);
    } else {
      var str = this.NationalInsuranceCardfiles[0].name;
      this.NationalInsuranceCardfileInput = str.slice(0, 25) + '...' + str.slice(-4);
    }

    if (this.NationalInsuranceCardfiles[0].type == "image/jpg" ||
      this.NationalInsuranceCardfiles[0].type == "application/pdf" ||
      this.NationalInsuranceCardfiles[0].type == "image/jpeg") {
      this.NationalInsuranceCardname = this.NationalInsuranceCardfiles[0].name;
      this.NationalInsuranceCardfileFormat = this.NationalInsuranceCardfiles[0].type;
      //console.log(this.fileFormat);
      //// console.log(this.files);
      var reader = new FileReader();
      reader.onload = this._handleReaderLoaddedNationalInsuranceCard.bind(this);
      reader.readAsBinaryString(this.NationalInsuranceCardfiles[0]);
    }
    else {
      this.loadingData1 = true;
      this._alert.openConfirmationDialo11("Please select a jpg/jpeg/pdf file to proceed.");
      return true;
    }

  }
  _handleReaderLoaddedNationalInsuranceCard(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.NationalInsuranceCardfilestring = btoa(binaryString); //Convaerting Binary String Data
    ////console.log(this.filestring);

  }

  onFileChangeBeneficial(event) {
    this.Beneficialfiles = event.target.files;

    if (this.Beneficialfiles[0].name.length < 30) {
      var str = this.Beneficialfiles[0].name;
      this.BeneficialfileInput = str.slice(0, 30);
    } else {
      var str = this.Beneficialfiles[0].name;
      this.BeneficialfileInput = str.slice(0, 25) + '...' + str.slice(-4);
    }

    if (this.Beneficialfiles[0].type == "image/jpg" ||
      this.Beneficialfiles[0].type == "application/pdf" ||
      this.Beneficialfiles[0].type == "image/jpeg") {
      this.Beneficialname = this.Beneficialfiles[0].name;
      this.BeneficialfileFormat = this.Beneficialfiles[0].type;
      //console.log(this.fileFormat);
      //// console.log(this.files);
      var reader = new FileReader();
      reader.onload = this._handleReaderLoaddedBeneficial.bind(this);
      reader.readAsBinaryString(this.Beneficialfiles[0]);
    }
    else {
      this.loadingData1 = true;
      this._alert.openConfirmationDialo11("Please select a jpg/jpeg/pdf file to proceed.");
      return true;
    }
  }

  _handleReaderLoaddedBeneficial(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.Beneficialstring = btoa(binaryString); //Convaerting Binary String Data

  }


  onFileChangeAuthorized(event) {
    this.Authorizedfiles = event.target.files;

    if (this.Authorizedfiles[0].name.length < 30) {
      var str = this.Authorizedfiles[0].name;
      this.AuthorizedfileInput = str.slice(0, 30);
    } else {
      var str = this.Authorizedfiles[0].name;
      this.AuthorizedfileInput = str.slice(0, 25) + '...' + str.slice(-4);
    }

    if (this.Authorizedfiles[0].type == "image/jpg" ||
      this.Authorizedfiles[0].type == "application/pdf" ||
      this.Authorizedfiles[0].type == "image/jpeg") {
      this.Authorizedname = this.Authorizedfiles[0].name;
      this.AuthorizedfileFormat = this.Authorizedfiles[0].type;
      //console.log(this.fileFormat);
      //// console.log(this.files);
      var reader = new FileReader();
      reader.onload = this._handleReaderLoaddedAuthorized.bind(this);
      reader.readAsBinaryString(this.Authorizedfiles[0]);
    }
    else {
      this.loadingData1 = true;
      this._alert.openConfirmationDialo11("Please select a jpg/jpeg/pdf file to proceed.");
      return true;
    }
  }

  _handleReaderLoaddedAuthorized(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.Authorizedstring = btoa(binaryString); //Convaerting Binary String Data

  }


  onFileChangeBusiness(event) {
    this.Businessfiles = event.target.files;

    if (this.Businessfiles[0].name.length < 30) {
      var str = this.Businessfiles[0].name;
      this.BusinessfileInput = str.slice(0, 30);
    } else {
      var str = this.Businessfiles[0].name;
      this.BusinessfileInput = str.slice(0, 25) + '...' + str.slice(-4);
    }

    if (this.Businessfiles[0].type == "image/jpg" ||
      this.Businessfiles[0].type == "application/pdf" ||
      this.Businessfiles[0].type == "image/jpeg") {
      this.Businessname = this.Businessfiles[0].name;
      this.BusinessfileFormat = this.Businessfiles[0].type;
      //console.log(this.fileFormat);
      //// console.log(this.files);
      var reader = new FileReader();
      reader.onload = this._handleReaderLoaddedBusiness.bind(this);
      reader.readAsBinaryString(this.Businessfiles[0]);
    }
    else {
      this.loadingData1 = true;
      this._alert.openConfirmationDialo11("Please select a jpg/jpeg/pdf file to proceed.");
      return true;
    }
  }

  _handleReaderLoaddedBusiness(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.Businessstring = btoa(binaryString); //Convaerting Binary String Data

  }



  IdentificationradioChange(event) {
    //console.log(event);
    this.Identifications = event.value;
    if (this.Identifications == "0") {
      this.uploadpassportfiles = true;
      this.UploadNationalInsurancefiles = false;
      this.passportNumberEnable=true;
      this.drivingLincenceNumberEnable=false;
    }
    else {
      this.UploadNationalInsurancefiles = true;
      this.uploadpassportfiles = false;
      this.passportNumberEnable=false
      this.drivingLincenceNumberEnable=true;
    }
  }



  onSelectedCountry(event) {

  }


  AddEnrollBusiness(enrollBusinessData) {


    this.loadingData1 = false;

    if (enrollBusinessData.NIBNumber == "" || enrollBusinessData.NIBNumber == null) {
      ////console.log("test");
      this.loadingData1 = true;
      this._alert.openConfirmationDialo11("Please Enter ID Number");
      return true;
    }


    //console.log(enrollBusinessData);
    if (this.enrollFormBusiness.valid) {



      //else {
      //// console.log(newEnrollData);
      enrollBusinessData.logintype = this.accounttype;

      enrollBusinessData.Beneficialuploadfile = this.Beneficialstring;
      enrollBusinessData.Authorizeduploadfile = this.Authorizedstring;
      enrollBusinessData.Businessuploadfile = this.Businessstring;


      enrollBusinessData.BeneficialFileName = this.Beneficialname;
      enrollBusinessData.AuthorizedFileName = this.Authorizedname;
      enrollBusinessData.BusinessFileName = this.Businessname;



      enrollBusinessData.identificationtype = this.Identifications;

      enrollBusinessData.DateofInception = this._datepipe.transform(enrollBusinessData.DateofInception.toString(), "MM/dd/yyyy");

      //console.log(enrollBusinessData)
      this._backendservice.postData(enrollBusinessData, `${CONFIG.enrollApiUrlBase}`)
        .subscribe(
          response => {
            if (response) {
              //  console.log("test");
              this.loadingData1 = true;
              this._alert.openConfirmationDialo11(response['msg']);
              //this._notificationService.showNotification({ message: response['msg'], type: 'success' });
              this.setForm2();
              this.uploadpassportfiles = false;
              this.UploadNationalInsurancefiles = false
            }
            else {
              this.loadingData1 = true;
              // console.log("test fail");
              this._notificationService.showNotification({ message: response['msg'], type: 'error' });
            }
          },
          error => {

          });
      //}


    }
    else {
      this.loadingData1 = true;
      //// console.log("enrollForm not valid.");
      this._alert.openConfirmationDialo11("Please fill  all the details.");
    }

  }




  AddEnroll(newEnrollData) {
    this.loadingData1 = false;
    //newEnrollData.Birthday = this._datepipe.transform(newEnrollData.Birthday.toString(), "MM/dd/yyyy");
    ////console.log(newEnrollData.Birthday)

    newEnrollData.logintype = this.accounttype;
    var dobb = newEnrollData.Birthday;
    var datenow = Date.now();

    const bdate = new Date(newEnrollData.Birthday);
    const timeDiff = Math.abs(Date.now() - bdate.getTime());
    var age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);

    if (newEnrollData.NIBNumber == "" || newEnrollData.NIBNumber == null) {
      ////console.log("test");
      this.loadingData1 = true;
      this._alert.openConfirmationDialo11("Please Enter NIB Number");
      return true;
    }

    if (newEnrollData.MiddleName == "") {
      ////console.log("test");
      this.loadingData1 = true;
      this._alert.openConfirmationDialo11(" If there is no middle name can  use ‘X’");
      return true;
    }
    if (age < 18) {
      this.loadingData1 = true;
      this._alert.openConfirmationDialo11("Age Should be 18 years above.");
      return true;
    }



    if (this.Identifications == "" || this.Identifications == null || this.Identifications == undefined) {
      this.loadingData1 = true;
      this._alert.openConfirmationDialo11("Please select the Identification Type.");
      return true;
    }

    if(newEnrollData.bankname==""|| newEnrollData.bankname==null|| newEnrollData.bankname==undefined){
      this.loadingData1 = true;
      this._alert.openConfirmationDialo11("Please fill the Bank Name.");
      return true;
    }
    if(newEnrollData.branch==""|| newEnrollData.branch==null|| newEnrollData.branch==undefined){
      this.loadingData1 = true;
      this._alert.openConfirmationDialo11("Please fill the Branch.");
      return true;
    }
    if(newEnrollData.accountnumber==""|| newEnrollData.accountnumber==null|| newEnrollData.accountnumber==undefined){
      this.loadingData1 = true;
      this._alert.openConfirmationDialo11("Please fill the Account Number.");
      return true;
    }





    //console.log(newEnrollData);
    if (this.enrollForm.valid) {

      // console.log(this.fileFormat)
      // if (this.fileFormat != "image/jpeg" || this.fileFormat != "image/jpg" || this.fileFormat  != "application/pdf" )  {

      //   this._alert.openConfirmationDialog(" Please select a file of type jpg or jpeg or pdf ");
      //   return true;
      // }



      if (newEnrollData.NewPassword != newEnrollData.ConfirmPassword) {
        //// console.log("test");
        this.loadingData1 = true;
        this._alert.openConfirmationDialo11("password and Confirm New password is not match.");
        return true;
      }

      if (newEnrollData.Email != newEnrollData.ConfirmEmail) {
        //// console.log("test");
        this.loadingData1 = true;
        this._alert.openConfirmationDialo11("Email and Confirm Email is not match.");
        return true;
      }

      else {
        //// console.log(newEnrollData);
        newEnrollData.Passportuploadfile = this.filestring;
        newEnrollData.passportFileName = this.name;

        //Driver’s License AND National Insurance Card
        newEnrollData.DriversLicenseuploadfile = this.DriversLicensefilestring;
        newEnrollData.DriversLicenseFileName = this.DriversLicensename;

        newEnrollData.NationalInsuranceCarduploadfile = this.NationalInsuranceCardfilestring;
        newEnrollData.NationalInsuranceCardFileName = this.NationalInsuranceCardname;

        newEnrollData.identificationtype = this.Identifications;

        newEnrollData.Birthday = this._datepipe.transform(newEnrollData.Birthday.toString(), "MM/dd/yyyy");
        newEnrollData.ExpiryDate = this._datepipe.transform(newEnrollData.expirydate.toString(), "MM/dd/yyyy");
        this._backendservice.postData(newEnrollData, `${CONFIG.enrollApiUrlBase}`)
          .subscribe(
            response => {
              if (response) {
                //  console.log("test");
                this.loadingData1 = true;
                this._alert.openConfirmationDialo11(response['msg']);
                //this._notificationService.showNotification({ message: response['msg'], type: 'success' });
            
                this.uploadpassportfiles = false;
                this.UploadNationalInsurancefiles = false
              }
              else {
                this.loadingData1 = true;
                // console.log("test fail");
                this._notificationService.showNotification({ message: response['msg'], type: 'error' });
              }
            },
            error => {

            });
      }


    }
    else {
      this.loadingData1 = true;
      //// console.log("enrollForm not valid.");
      this._alert.openConfirmationDialo11("Please fill  all the details.");
    }
  }

  setFormBusiness() {

    this.enrollFormBusiness = new FormGroup({


      NIBNumber: new FormControl('', [Validators.pattern('^([0-9]).{7,8}$')]),
      Bname: new FormControl('', [Validators.required]),
      trading: new FormControl(''),
      Btype: new FormControl('', [Validators.required]),
      Baddress: new FormControl('', [Validators.required]),
      Bemailaddress: new FormControl('', [Validators.required]),
      DateofInception: new FormControl('', [Validators.required]),

      //Primary
      BPemailaddress: new FormControl('', [Validators.required]),
      BPname: new FormControl('', [Validators.required]),
      BPphone: new FormControl('', [Validators.required]),
      //Secondary

      SBname: new FormControl(''),
      SBemailaddress: new FormControl(''),
      SBphone: new FormControl(''),
      //Bank Info
      Bbankname: new FormControl(''),
      Bbranch: new FormControl(''),
      Baccountnumber: new FormControl(''),

//documents

      beneficialdocs: new FormControl(''),
      authorizeddocs: new FormControl(''),
      Businessdocs: new FormControl(''),
    });


  }

    setForm2() {

    this.enrollFormBusiness = new FormGroup({

      NIBNumber: new FormControl(''),
      Bname: new FormControl(''),
      trading: new FormControl(''),
      Btype: new FormControl(''),
      Bemailaddress: new FormControl(''),
      Bphone: new FormControl(''),
      DateofInception: new FormControl(''),

      BPemailaddress: new FormControl(''),
      BPname: new FormControl(''),
      BPphone: new FormControl(''),
      //Secondary

      SBname: new FormControl(''),
      SBemailaddress: new FormControl(''),
      SBphone: new FormControl(''),
      //Bank Info
      Bbankname: new FormControl(''),
      Bbranch: new FormControl(''),
      Baccountnumber: new FormControl(''),

      Baddress: new FormControl(''),
      beneficialdocs: new FormControl(''),
      authorizeddocs: new FormControl(''),
      Businessdocs: new FormControl(''),
    });
  }


}
